module.exports = __webpack_public_path__ + "img/u392.6c69abda.svg";